const SPECIAL_LATIN_REPLACEMENTS = {
  ß: "ss",
  Œ: "OE",
  œ: "oe",
  Ĳ: "IJ",
  ĳ: "ij",
  Æ: "AE",
  Ǽ: "AE",
  æ: "ae",
  ǽ: "ae",
  Ð: "Dj",
  ð: "dj",
  ƒ: "f",
};

const SPECIAL_LATIN_PATTERN = new RegExp(
  `[${Object.keys(SPECIAL_LATIN_REPLACEMENTS).join("")}]`,
  "gu",
);

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function convertAccentedCharacters(str) {
  if (!str) return "";
  return String(str)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(SPECIAL_LATIN_PATTERN, (ch) => SPECIAL_LATIN_REPLACEMENTS[ch] ?? ch);
}

function urlTitle(str, separator = "-", lowercase = true) {
  let s = String(str).replace(/<[^>]*>/g, "").replace(/&.+?;/g, "");
  s = s.replace(/[^\w\d _-]/gu, "").replace(/\s+/g, separator);
  const escapedSep = escapeRegExp(separator);
  s = s.replace(new RegExp(`(${escapedSep})+`, "g"), separator);
  if (lowercase) {
    s = s.toLowerCase();
  }
  s = s.replace(new RegExp(`^${escapedSep}+|${escapedSep}+$`, "g"), "");
  return s.trim();
}

export function channelNameToUrlSlug(name) {
  const converted = convertAccentedCharacters(name == null ? "" : name);
  return urlTitle(converted, "-", true);
}
